export default "<p>&lt;!-- @api: OtTabs.vue/OtTabsAPI.md --&gt;</p>\n<h1>Tabs 标签页</h1>\n<p>分隔内容上有关联但属于不同类别的数据集合。</p>\n"